import { ChildrenProp } from '@/common/types_and_interfaces.ts'

export function FullCenteredMain({ children }: ChildrenProp) {
  return (
    <main className="grow flex items-center flex-col justify-center">
      {children}
    </main>
  )
}